import { useViewVehicleContext } from 'pages/Admin/ViewVehicle/context/ViewVehicleContext';
import styled from 'styled-components';
import { Interior } from './Interior';
import { Exterior } from './Exterior';
import { Mechanical } from './Mechanical';

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  min-height: 300px;
  border-radius: 8px;
  display: flex;

  gap: 8px;
  background: #f9f9f9;
`;

const SectionsWrapper = styled.div<{ $forceColumn?: boolean; $twoColumn?: boolean }>`
  display: ${({ $twoColumn }) => ($twoColumn ? 'grid' : 'flex')};
  grid-template-columns: ${({ $twoColumn }) => ($twoColumn ? '1fr 1fr' : 'unset')};
  padding: 16px;
  gap: 8px;
  width: 100%;
  overflow-x: scroll;
  flex-direction: ${({ $forceColumn }) => ($forceColumn ? 'column' : 'row')};

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
  }
`;

type Props = {
  forceMobileLayout?: boolean;
  twoColumnLayout?: boolean;
};

export const SectionLayout = ({ forceMobileLayout, twoColumnLayout }: Props) => {
  return (
    <Wrapper>
      <SectionController forceMobileLayout={forceMobileLayout} twoColumnLayout={twoColumnLayout} />
    </Wrapper>
  );
};

const sectionToComponent: Record<string, () => JSX.Element> = {
  interior: Interior,
  exterior: Exterior,
  mechanical: Mechanical
};

const SectionController = ({ forceMobileLayout, twoColumnLayout }: Props) => {
  const { activeSection, setActiveSection } = useViewVehicleContext();

  const SectionComponent = sectionToComponent[activeSection];
  if (!SectionComponent) return null;

  return (
    <SectionsWrapper $forceColumn={forceMobileLayout} $twoColumn={twoColumnLayout}>
      <SectionComponent />
    </SectionsWrapper>
  );
};
